/* Oates Specialties — shared header chrome JS
   Handles: Shop dropdown (click + hover), mobile hamburger, mobile search.
   Idempotent: safe to load on any page that includes the standard header markup.
*/
(function () {
  'use strict';

  // ---------- Mobile hamburger + mobile search ----------
  var hamburger = document.getElementById('hamburger-btn');
  var mobileNav = document.getElementById('mobile-nav');
  var searchBtn = document.getElementById('mobile-search-btn');
  var mobileSearch = document.getElementById('mobile-search');
  var searchClose = document.getElementById('mobile-search-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.hidden = false;
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    if (mobileSearch && !mobileSearch.hidden) closeMobileSearch();
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.hidden = true;
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }
  function toggleMobileNav() {
    if (!mobileNav) return;
    mobileNav.hidden ? openMobileNav() : closeMobileNav();
  }

  function openMobileSearch() {
    if (!mobileSearch) return;
    mobileSearch.hidden = false;
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    if (mobileNav && !mobileNav.hidden) closeMobileNav();
    var input = mobileSearch.querySelector('input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function closeMobileSearch() {
    if (!mobileSearch) return;
    mobileSearch.hidden = true;
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
  }
  function toggleMobileSearch() {
    if (!mobileSearch) return;
    mobileSearch.hidden ? openMobileSearch() : closeMobileSearch();
  }

  if (hamburger) hamburger.addEventListener('click', toggleMobileNav);
  if (searchBtn) searchBtn.addEventListener('click', toggleMobileSearch);
  if (searchClose) searchClose.addEventListener('click', closeMobileSearch);

  if (mobileNav) {
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeMobileNav();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mobileNav && !mobileNav.hidden) closeMobileNav();
    if (mobileSearch && !mobileSearch.hidden) closeMobileSearch();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 901) {
      if (mobileNav && !mobileNav.hidden) closeMobileNav();
      if (mobileSearch && !mobileSearch.hidden) closeMobileSearch();
    }
  });

  // ---------- Shop dropdown ----------
  var dd = document.getElementById('shop-dropdown');
  if (dd) {
    var trigger = dd.querySelector('.nav-dropdown__trigger');
    if (trigger) {
      var openDD = function () {
        dd.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      var closeDD = function () {
        dd.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };
      var toggleDD = function () {
        dd.classList.contains('is-open') ? closeDD() : openDD();
      };

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        toggleDD();
      });

      var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (hoverCapable) {
        var closeTimer = null;
        dd.addEventListener('mouseenter', function () {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          openDD();
        });
        dd.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(closeDD, 150);
        });
      }

      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) closeDD();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDD();
      });
    }
  }
})();
